import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Heart, Globe, Award, Sparkles, CheckCircle, ArrowRight, Truck } from 'lucide-react';

const LOGO = "https://customer-assets.emergentagent.com/job_aura-k-beauty/artifacts/kjkn7c10_3.png";

const values = [
  { icon: CheckCircle, title: "Autenticidad", desc: "Todos nuestros productos son 100% originales, importados directamente de Corea del Sur con trazabilidad completa." },
  { icon: Globe, title: "Accesibilidad", desc: "Traemos lo mejor del K-beauty a Puerto Rico, eliminando las barreras de distancia y lenguaje." },
  { icon: Award, title: "Calidad Premium", desc: "Seleccionamos cuidadosamente cada producto basandonos en ingredientes, investigacion y resenas reales." },
  { icon: Sparkles, title: "Educacion", desc: "No solo vendemos productos. Te ensenamos a cuidar tu piel con guias, rutinas y contenido educativo en espanol." },
  { icon: Heart, title: "Confianza", desc: "Cada recomendacion esta respaldada por conocimiento real del skincare coreano y sus ingredientes." },
  { icon: Truck, title: "Envio Seguro", desc: "Embalaje cuidadoso y envio rapido en todo Puerto Rico para que tus productos lleguen perfectos." },
];

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-[var(--cream)]" data-testid="about-page">
      {/* Hero */}
      <div className="bg-white py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[var(--dark)] leading-tight">
                Nuestra <span className="gradient-text">Historia</span>
              </h1>
              <p className="text-base text-[var(--dark)]/60 leading-relaxed">
                Aura K Beauty nacio de una pasion profunda por el skincare coreano y el deseo de compartir sus increibles beneficios con la comunidad de Puerto Rico. Despues de experimentar de primera mano la transformacion que los productos coreanos pueden lograr, decidimos crear un puente entre Corea del Sur y nuestra isla.
              </p>
              <p className="text-base text-[var(--dark)]/60 leading-relaxed">
                Somos una tienda dedicada a traer lo mejor del skincare coreano autentico y a educar a nuestros clientes sobre como cuidar su piel con los mejores ingredientes e innovaciones del mundo de la belleza coreana.
              </p>
              <p className="text-base text-[var(--dark)]/60 leading-relaxed">
                Creemos que la belleza autentica comienza con el cuidado, y que todos merecen acceso a productos de calidad premium que realmente funcionan. Por eso seleccionamos cuidadosamente cada producto de nuestro catalogo.
              </p>
              <Link to="/tienda">
                <Button className="bg-[var(--violet)] text-white rounded-full px-8 h-11 mt-2" data-testid="about-shop-btn">
                  Explorar Productos <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </Link>
            </div>
            <div className="flex justify-center">
              <div className="relative">
                <div className="absolute inset-0 bg-[var(--sage)] rounded-3xl rotate-3 opacity-40"></div>
                <img src={LOGO} alt="Aura K Beauty" className="relative rounded-3xl w-80 h-80 object-cover shadow-lg" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Values */}
      <div className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl sm:text-3xl font-bold text-[var(--dark)] text-center mb-4">Nuestros Valores</h2>
          <p className="text-base text-[var(--dark)]/50 text-center mb-12 max-w-lg mx-auto">Lo que nos hace diferentes y por que puedes confiar en Aura K Beauty.</p>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {values.map((v, i) => (
              <div key={i} className="bg-white rounded-2xl p-6 text-center border border-[var(--sage)]/20 hover:shadow-md transition-shadow" data-testid={`value-${i}`}>
                <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-[var(--violet-light)] flex items-center justify-center">
                  <v.icon className="h-6 w-6 text-[var(--violet)]" />
                </div>
                <h3 className="text-base font-bold text-[var(--dark)] mb-2">{v.title}</h3>
                <p className="text-sm text-[var(--dark)]/50 leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Mission */}
      <div className="py-16 bg-[var(--violet)] text-white">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-2xl sm:text-3xl font-bold mb-4">Nuestra Mision</h2>
          <p className="text-lg text-white/80 leading-relaxed mb-6">
            Traer lo mejor del skincare coreano a Puerto Rico, educando a nuestra comunidad sobre ingredientes innovadores y rutinas que transforman la piel. Porque la belleza autentica comienza con el cuidado.
          </p>
          <p className="text-base text-white/60 leading-relaxed">
            Queremos que cada persona que visite Aura K Beauty se sienta empoderada con el conocimiento para elegir los productos correctos para su piel, y que experimente los resultados reales que solo el K-Beauty autentico puede ofrecer.
          </p>
        </div>
      </div>

      {/* CTA */}
      <div className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-2xl sm:text-3xl font-bold text-[var(--dark)] mb-4">Tienes preguntas?</h2>
          <p className="text-base text-[var(--dark)]/50 mb-8">Estamos aqui para ayudarte a encontrar la rutina perfecta para tu piel.</p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/contacto">
              <Button className="bg-[var(--violet)] text-white rounded-full px-8 h-11">Contactanos</Button>
            </Link>
            <a href="https://wa.me/17879491006?text=Hola%20Aura%20K%20Beauty!" target="_blank" rel="noopener noreferrer">
              <Button variant="outline" className="border-[var(--sage-dark)] text-[var(--sage-dark)] rounded-full px-8 h-11">WhatsApp</Button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
